module.exports = __webpack_public_path__ + "img/home-page-mask-img-mobile.3d58ef4f.png";